import { render, staticRenderFns } from "./customer-loan-request.vue?vue&type=template&id=38f873ae&scoped=true&"
import script from "./customer-loan-request.vue?vue&type=script&lang=js&"
export * from "./customer-loan-request.vue?vue&type=script&lang=js&"
import style0 from "./customer-loan-request.vue?vue&type=style&index=0&id=38f873ae&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f873ae",
  null
  
)

export default component.exports